import React from "react";
import xss from "xss";
import { connect } from "react-redux";
import disableBrowserBackButton from "disable-browser-back-navigation";
import axios from "axios";
import { Modal as bsModal } from "bootstrap";
import { Alert } from "react-bootstrap";

import { Link, useMatch, useNavigate } from "../utils/components/router";
import Timeout from "../utils/components/Timeout";
import Messages from "../pages/Messages";
import VerifyForm from "../popups/VerifyForm";
import { RAGE_RIGHT } from "../utils/enums/RAGE_RIGHT";
import PERSONART from "../utils/enums/PERSONART";
import { BERATER_KENNZEICHEN } from "../utils/enums/BERATER_KENNZEICHEN";
import PageHeader from "./PageHeader";
import { orderFunctions, isAuthenticated, checkResize, scrollToTop } from "../utils/functions";
import RESPONSE_HEADER from "../utils/enums/RESPONSE_HEADER";
import CONFIG from "../config";
import { orderButtonText } from "../utils/enums/CONSTANTS";
import KundeLogin from "./KundeLogin";
import { Address, Order, Summe, RechtlicheHinweise, KundenDaten } from "./components";
import { KontoDeckungPopup } from "../popups/kontoDeckungPopup";
import { basketActions } from "../actions";
import { BackToStartButton } from '../partial';
import TanAuth from "../pages/TanAuth";
import ServiceContactInfo from "../partial/ServiceContactInfo";

class KundenOrderDetailsMA extends React.Component {
  constructor(props) {
    super(props);
    this.checkFormular = this.checkFormular.bind(this);
    this.sendOrder = this.sendOrder.bind(this);
    this.setState = this.setState.bind(this);
    this.handleGeneralChange = this.handleGeneralChange.bind(this);
    this.akzeptiereNichtGedecktesKonto = this.akzeptiereNichtGedecktesKonto.bind(this);
    this.checkSendOrder = this.checkSendOrder.bind(this);
    this.cleanupModal = this.cleanupModal.bind(this);
    this.handleRemark = this.handleRemark.bind(this);
    this.updateHinweise = this.updateHinweise.bind(this);
    this.updateDeuBaOrderButtonDisabled = this.updateDeuBaOrderButtonDisabled.bind(this);
  }

  componentDidCatch(error, info) {
    this.setState({ catchError: true });
  }

  state = {
    showBeraterErrorMsg: false,
    beraterFeld: this.initializeBeraterFeld(),
    emProvZusKz: "N",
    gesamtProvision: 0,
    beraterkennzeichen: this.props.configStorage.getBeraterKennzeichen(),
    rechtlichesHinweis: [false, false, false, false, false],
    showRechtlichesHinweisErrorMsg: [false, false, false, false, false],
    showVerifyErrorMsg: false,
    tlsCodeVerifyFailed: false,
    tlsCodeVerifyCount: 0,
    kontoDeckungVerifyFailed: false,
    bemerkungen: this.initializeBemerkungen(),
    validateBankApi: true,
    showRequiredWarning: false,
    deubaOrderButtonDisabled: this.props.configStorage.isDeuBa() ? "disabled deubaOrderDisabled":"",
  };

  componentDidMount() {
    if (CONFIG.isEdelmetallShop()) {
      this.setState({
        emProvZusKz: this.props.basketStorage.gebuehren
          ? this.props.basketStorage.gebuehren.emProvisionZusatzKz || "N"
          : "N"
      });
    }
    disableBrowserBackButton();
    checkResize();
  };

  componentDidUpdate() {
    if (this.state.tlsCodeVerifyFailed || this.state.kontoDeckungVerifyFailed) {
      const modal = document.querySelector("#flipFlopp");
      if (modal) {
        bsModal.getOrCreateInstance(modal).show();
      }
    }
  }

  cleanupModal() {
    this.setState({ kontoDeckungVerifyFailed: false });
    this.setState({ tlsCodeVerifyFailed: false });
    const modal = document.querySelector("#flipFlopp");
    if (modal) {
      bsModal.getOrCreateInstance(modal).dispose();
    }
  }

  //return list of empty strings depend on the number of warenkorbposition
  initializeBemerkungen() {
    const warenkorbPos = this.props.basketStorage.getWarenkorbPos();
    return new Array(warenkorbPos ? warenkorbPos.length : 0).fill("");
  }

  //return enum BERATER_KENNZEICHEN
  initializeBeraterFeld() {
    if (!this.props.configStorage.isMaShop()) return "N";
    switch (this.props.configStorage.getBeraterKennzeichen()) {
      case BERATER_KENNZEICHEN.DEFAULT_NONE_SELECT_YES_NO:
        return "none";
      case BERATER_KENNZEICHEN.DEFAULT_YES_SELECT_NONE:
      case BERATER_KENNZEICHEN.DEFAULT_YES_SELECT_YES_NO:
        return "J";
      case BERATER_KENNZEICHEN.DEFAULT_NONE_SELECT_NONE:
        return null;
      default:
        return "N";
    }
  }

  navigate({ path, error, message }) {
    if (error) {
      this.props.navigate("/error", error);
    } else if (path && message) {
      this.props.navigate(path, { errorMsg: message });
    } else if (path) {
      this.props.navigate(path);
    }
  }

  sendOrder(tlsCode, passwort) {
    let kunde = this.props.kundenStorage.getKunde();
    let adresseId = xss(this.props.params.id);
    let dataForOrder = this.props.basketStorage.getDataForOrder();
    this.setState({ sendOrderClicked: true, showVerifyErrorMsg: false });
    let warenkorbId = this.props.basketStorage.warenkorbId;
    let requestData = this.props.configStorage.getRequestData("order", "post");
    let blz = this.props.configStorage.getBankId();
    let warenkorbData = JSON.parse(JSON.stringify(dataForOrder.orderData)); // clone before change
    let userId = this.props.authenticationStorage.userId;
    warenkorbData.order.angebotsNr = warenkorbId;
    let selectedFiliale = dataForOrder.selectedFiliale;
    let header = requestData.json ? requestData.json.header : this.props.configStorage.getRequestHeader();
    let config = {
      headers: {
        ...(requestData.config ? requestData.config.headers || {} : {}),
        request: JSON.stringify(header)
      }
    };
    let axiosVerify = axios.create(config);
    requestData.url = requestData.url + warenkorbId;
    const bestellerInformationen = this.props.kundenStorage.getBestellerInfo(adresseId);
    const orderData = {
      bestellerInformationen: {
        ...bestellerInformationen,
        lieferadressennummer: selectedFiliale ? selectedFiliale.value : "0",
        lieferfilialadresse: selectedFiliale ? selectedFiliale.address : null,
        blzGP: blz,
        lieferfilialname: selectedFiliale ? selectedFiliale.name : null,
        direktversandKz: dataForOrder.doShip === "no" ? "N" : "J",
      },
      rechtlichesHinweis1: this.state.rechtlichesHinweis[0] ? (this.state.rechtlichesHinweis[0] === "option1" ? 1 : 2) : 0,
      rechtlichesHinweis2: this.state.rechtlichesHinweis[1] ? 1 : 0,
      rechtlichesHinweis3: this.state.rechtlichesHinweis[2] ? 1 : 0,
      rechtlichesHinweis4: this.state.rechtlichesHinweis[3] ? 1 : 0,
      rechtlichesHinweis5: this.state.rechtlichesHinweis[4] || this.props.configStorage.isMaShop() ? 1 : 0,
      tlsCode: tlsCode,
      passwort: passwort,
      userId: userId,
      beraterKz: this.state.beraterFeld,
      kundenId: kunde.id,
      bemerkungen: this.state.bemerkungen,
      validateBankApi: this.state.validateBankApi,
      innenprovision: this.props.basketStorage.calcInnenProvision()
    };
    const shopData = CONFIG.getShopConfig({
      edelmetall: {
        edelmetallWarenkorb: warenkorbData.order,
        edelmetallWarenkorbPos: warenkorbData.edelmetallWarenkorbPosRequest,
        emProvZusKz: this.state.emProvZusKz
      },
      sorten: {
        sortenWarenkorb: warenkorbData.order,
        sortenWarenkorbPos: warenkorbData.sortenWarenkorbPosRequest
      }
    });
    if (this.props.configStorage.isVerseNeo() && this.props.configStorage.isKundenShop()) {
      this.setState({
        postOrderData: {
          ...(requestData.json || {}),
          ...orderData,
          ...shopData
        }
      });
      return;
    }
    axiosVerify[requestData.request.type](requestData.url, {
      ...(requestData.json || {}),
      ...orderData,
      ...shopData,
    }).then(orderResponse => {
      // TODO: If-Zweig in orderFunctions mit einbauen, momentan Probleme mit setState, müsste eventuell auch über Redux laufen
      const header = orderResponse && orderResponse.data && orderResponse.data.header ? orderResponse.data.header : {};
      if (header.errorNr === RESPONSE_HEADER.ERRORNUMMER.TLS_VALIDIERUNG) {
        this.setState({
          sendOrderClicked: false,
          tlsCodeVerifyFailed: true,
          tlsCodeVerifyCount: this.state.tlsCodeVerifyCount + 1
        });
      } else if (header.errorNr === RESPONSE_HEADER.ERRORNUMMER.TLS_LOGIN_VERSUCHE) {
        this.setState({ showVerifyErrorMsg: true });
      } else if (header.errorNr === RESPONSE_HEADER.ERRORNUMMER.KONTODECKUNG) {
        this.setState({ sendOrderClicked: false, kontoDeckungVerifyFailed: true });
      } else {
        this.setState({ tlsCodeVerifyFailed: false, tlsCodeVerifyCount: 0 });
        if (this.props.configStorage.isVerseNeo()) {
          this.props.dispatch(basketActions.setBankApiResponseData(orderResponse.data));
        }
        scrollToTop();
        this.navigate(orderFunctions.processResponse(orderResponse, kunde.id, this.props.configStorage.isMaShop()));
      }
    }).catch(error => {
      this.navigate(orderFunctions.processOrderError(error));
    });
  }

  updateDeuBaOrderButtonDisabled(beratungSelection, data) {
    const currentBeraterkennzeichen = this.props.configStorage.getBeraterKennzeichen();
    let beraterValid = true;

    // Validation Beratung erhalten? 
    // if beraterkennzeichen DEFAULT_NONE_SELECT_YES_NO 
    if (currentBeraterkennzeichen === BERATER_KENNZEICHEN.DEFAULT_NONE_SELECT_YES_NO && beratungSelection === "none") {
      beraterValid = false;
    }
    const required = this.getRequiredHinweise();
    const formularFilled = required.reduce(
      (prev, hinweis) => {
        return prev && data.rechtlichesHinweis[hinweis];
      },
      beraterValid
    );    
    this.setState({
        deubaOrderButtonDisabled: (beraterValid && formularFilled) ? "":"disabled deubaOrderDisabled"
    })
  }

  checkFormular(beratungSelection) {
    const currentBeraterkennzeichen = this.props.configStorage.getBeraterKennzeichen();
    let beraterValid = true;

    // Validation Beratung erhalten? 
    // if beraterkennzeichen DEFAULT_NONE_SELECT_YES_NO 
    if (currentBeraterkennzeichen === BERATER_KENNZEICHEN.DEFAULT_NONE_SELECT_YES_NO && beratungSelection === "none") {
      this.setState({ showBeraterErrorMsg: true });
      beraterValid = false;
    }
    const required = this.getRequiredHinweise();
    const errorMsgs = this.state.rechtlichesHinweis.map((rh, idx) => {
      return !rh && required.includes(idx);
    });
    const formularFilled = required.reduce(
      (prev, hinweis) => {
        return prev && this.state.rechtlichesHinweis[hinweis];
      },
      !this.state.showBeraterErrorMsg
    );
    this.setState({
      showRequiredWarning: !beraterValid || !formularFilled,
      showRechtlichesHinweisErrorMsg: errorMsgs
    });
    return beraterValid && formularFilled;
  }

  updateHinweise(data) {
    if (!data) return;
    const errorMsg = data.showRechtlichesHinweisErrorMsg || this.state.showRechtlichesHinweisErrorMsg;
    const showBeraterErrorMsg = data.showBeraterErrorMsg || this.state.showBeraterErrorMsg;
    this.setState({
      ...data,
      showRequiredWarning: (errorMsg || []).reduce((prev, m) => prev || m,
        !!showBeraterErrorMsg
      )
    });
    if (this.props.configStorage.isDeuBa()) {
      this.updateDeuBaOrderButtonDisabled(this.state.beraterFeld, data);
    }
  }

  checkSendOrder() {
    if (
      this.checkFormular(this.state.beraterFeld) &&
      this.state.sendOrderClicked !== true
    ) {
      this.sendOrder(null, null);
    }
  }

  akzeptiereNichtGedecktesKonto() {
    this.setState({ validateBankApi: false }, this.closePopupAndOrder);
  }

  closePopupAndOrder = () => {
    const modal = document.querySelector("#flipFlopp");
    if (modal) {
      bsModal.getOrCreateInstance(modal).hide();
    }
    this.sendOrder(null, null);
  };

  handleGeneralChange(e) {
    if (!e || !e.target) return;
    let { name, value } = e.target;
    let showBeraterErrorMsg = (value === "J" || value === "N");
    this.setState({
      showBeraterErrorMsg: !showBeraterErrorMsg,
      [name]: value,
    }, () => {
      if (this.props.configStorage.isDeuBa()) {
        this.updateDeuBaOrderButtonDisabled(value, {
            ...this.state
          });
        }
    });
  }

  handleRemark(e, index) {
    e.preventDefault();
    const bemerkungen = Array.isArray(this.state.bemerkungen) ? this.state.bemerkungen : [];
    let bemerkungenNeu = [...bemerkungen];
    bemerkungenNeu[index] = xss(e.target.value);
    this.setState({ bemerkungen: bemerkungenNeu });
  }

  onSubmit = formValues => {
    if (this.state.sendOrderClicked !== true) {
      const modal = document.querySelector("#flipFlopp");
      if (modal) {
        bsModal.getOrCreateInstance(modal).hide();
      }
      this.sendOrder(formValues.tlsCode, formValues.passwort);
    }
  };

  checkForVerifyForm() {
    // nicht in VerseNeo
    if (CONFIG.VERSE_NEO || CONFIG.DEUBA) return false;
    // kunde ist angemeldet und es KundenShop
    // oder Berater ist angemeldet und es ist Direktversand
    return (
      this.props.authenticationStorage.isSignedIn &&
      this.props.configStorage.isKundenShop()
    ) ||
      (
        this.props.authenticationStorage.isUserSignedIn &&
        this.props.configStorage.isMaShop() &&
        this.props.basketStorage.isDirectOrder()
      );
  }

  getRequiredHinweise() {
    let requiredHinweise = [];
    if (this.props.configStorage.isKundenShop()) { //berater-verkauf
      requiredHinweise = [0, 1, 2, 3, 4];
    } else if (this.props.configStorage.isAnkaufShop()) { //berater-ankauf
      requiredHinweise = [0, 1, 3];
    } else { //verkauf
      requiredHinweise = [0, 1, 2, 3];
    }
    return requiredHinweise;
  }

  renderBestaetigung() {
    const formularFilled = this.getRequiredHinweise().reduce(
      (prev, hinweis) => {
        return prev && this.state.rechtlichesHinweis[hinweis];
      },
      true
    );

    if (this.checkForVerifyForm()) {
      return (
        <VerifyForm
          checkFormular={this.checkFormular}
          beraterFeld={this.state.beraterFeld}
          showVerifyErrorMsg={this.state.showVerifyErrorMsg || this.state.tlsCodeVerifyCount > 4}
          filled={this.state.beraterFeld !== "none" && formularFilled}
          tlsCodeVerifyFailed={this.state.tlsCodeVerifyFailed}
          kontoDeckungVerifyFailed={this.state.kontoDeckungVerifyFailed}
          onSubmit={this.onSubmit}
          akzeptiereNichtGedecktesKonto={this.akzeptiereNichtGedecktesKonto}
        />
      );
    } else {
      return (
        <div className="col-12 col-md-4 col-lg-3 float-end">
          <Link className={`btn btn-success col-12 ${this.state.deubaOrderButtonDisabled}`}
            onClick={this.checkSendOrder}
            to="#"
          >                    
          {orderButtonText}
          </Link>
          <KontoDeckungPopup
            akzeptiereNichtGedecktesKonto={this.akzeptiereNichtGedecktesKonto}
          ></KontoDeckungPopup>
        </div>
      );
    }
  }

  checkDifferenzBesteuerung() {
    if (CONFIG.isSortenShop()) return false;
    let kunde = this.props.kundenStorage.getKunde();
    // Die Personenarten P, N und G haben keinerlei Auswirkung auf die Aufträge.
    // Diese 3 Personenarten können alle Produkte bestellen und ankaufen
    if (
      kunde &&
      kunde.personArt !== PERSONART.JURISTISCHE_PERSON.KUERZEL
    ) {
      return false;
    }
    // Kunden mit Personenart "J" können keine Aufträge (Ankäufe und Bestellung) mit Produkten erfassen,
    // die das Kennzeichen "Reverse Charge" haben
    const rchargeKZ = this.props.basketStorage.items.reduce((prev, item) => prev || item.rchargeKz, false);
    if (rchargeKZ) return true;

    // Bei Kunden mit Personenart "J" können Produkte mit Mehrwertsteuer(aber ohne Reverse Charge)
    // nur bestellt werden. Ankäufe sind nicht möglich.
    if (!this.props.configStorage.isAnkaufShop()) return false;

    // wenn diffsteuerungKz === "N", dann pruefen, (git nur für Ankaufshop und Person "J" oder "P")
    // anschließend weitere pruefungen.
    // Bank kauft nur 1 Element gleichzeitig an, deswegen reicht hier die pruefung des ersten Elements
    let item = this.props.basketStorage.items[0];
    if (item) {
      if (!item.diffsteuerungKz) {
        // hier muss geprueft werden, ob Muenze aus Silber oder Palladium oder Platinum       
        if (item.make === "coin" && (item.kind === "silver" || item.kind === "palladium" || item.kind === "platinum")) {
          return true;
        }
      }
      // deprecated: die kennziffern gibt es nicht mehr (was waren das für Produkte?)
      if (item.kennziffer === "62840" || item.kennziffer === "62841") {
        return true;
      }
    }
    // wurde eine steuer berechnet
    return (this.props.basketStorage.sumTaxes.getPrice() > 0);
  }

  renderSendOrder() {
    let message = "Ihre Order wird bearbeitet. Bitte warten Sie einen Moment. Die Erstellung der Auftragsbestätigung kann bis zu einer Minute dauern, vielen Dank für Ihre Geduld.";
    return (
      <div id={CONFIG.SHOP_ID}>
        <PageHeader />
        <section className="if6_outer section if6_section full-height">
          <div className="bootstrap-iso">
            <div className="container p-one">
              <Messages message={message} type="info" />
            </div>
          </div>
        </section>
      </div>
    );
  }

  renderDifferenzBesteuerung() {
    const { kundenStorage, basketStorage, mandantStorage, configStorage } = this.props;
    const kunde = kundenStorage.getKunde();
    const messageText = [
      "Umsatzsteuerpflichtige Aufträge sind bei juristischen Personen nicht möglich (Reverse-Charge).",
      "Bitte passen sie Ihren Warenkorb entsprechend auf steuerfreie Edelmetalle an oder verwenden Sie die Kontoverbindung einer natürlichen Person."
    ];
    const message = "Fehlermeldung:";
    return (
      <div>
        <section className="if6_outer section if6_section full-height">
          <div className=" bootstrap-iso">
            <Messages messageText={messageText} message={message} type="error" >
              <div className="d-flex w-100">
                <div className="col-6 col-md-3">
                  <Link
                    to={configStorage.getBackToShopLink()}
                    className="btn btn-info">
                    Zurück zum Shop
                  </Link>
                </div>
                {configStorage.kundeIsSelectable()
                  ? <div className="col-6 col-md-3 col-md-push-1">
                    <Link
                      to={configStorage.getLinkPath("LINK_MITARBEITER_ADD_KUNDEN")}
                      className="btn btn-default"
                    >
                      Zu Kundendaten
                    </Link>
                  </div>
                  : null
                }
                {mandantStorage.lieferadresseIsEditable() && basketStorage.selectedFiliale === null && !configStorage.isDeuBa()
                  ? <div className="col-6 col-md-3 col-md-push-1 ms-one">
                    <Link
                      to={configStorage.getLinkPath("LINK_KUNDEN_ADDRESSE_MA", kunde.id)}
                      className="btn btn-default"
                    >
                      Zu Kundenadressen
                    </Link>
                  </div>
                  : null
                }
              </div>
            </Messages>
          </div>
        </section>
      </ div>
    );
  }

  render() {
    const { params, kundenStorage, basketStorage, mandantStorage, configStorage, authenticationStorage } = this.props;
    if (!params) {
      return null;
    }
    if (!isAuthenticated(this.props)) {
      return (<KundeLogin />);
    }
    if (this.state.sendOrderClicked) {
      if (this.props.configStorage.isVerseNeo() && this.props.configStorage.isKundenShop()) {
        scrollToTop();
        return (
          <TanAuth postOrderData={this.state.postOrderData} />
        );
      } else {
        return this.renderSendOrder();
      }
    }
    if (this.checkDifferenzBesteuerung()) {
      return this.renderDifferenzBesteuerung();
    }

    let kunde = kundenStorage.getKunde();
    if (!kunde) {
      return <div className="bootstrap-iso">
        <div className="row">
          <Alert className="col-12" variant="error">Es sind keine Kundendaten vorhanden</Alert>
          <div className="col-md-2">
            <Link
              onClick={this.cleanupModal}
              to={configStorage.getBackToShopLink()}
              className="btn btn-info col-12"
            >
              Zurück zum Shop
            </Link>
          </div>
        </div>
      </div>;
    }
    let direktbestellung = basketStorage.isDirectOrder();
    return (
      <div id={CONFIG.SHOP_ID}>
        <section className="if6_outer section if6_section">
          <div className="if6_inner">
            <div className="no-if6-changes">
              <h1 className="ser-appheadline">{
                CONFIG.SHOP_NAME +
                (configStorage.isAnkaufShop()
                  ? "-Ankauf"
                  : "-Bestellung"
                )}
              </h1>
            </div>
            <Timeout />
          </div>
        </section>
        <section className="if6_outer section if6_section full-height">
          <div className="bootstrap-iso">
            <div className="container bg-white p-one">
              <h2 className="text-h2-secondary text-start mb-one">
                Bitte prüfen Sie Ihren Auftrag
              </h2>
              <section className="row mb-two" aria-label="Besteller">
                <div className="col-12 col-lg-6 fs-sm-6">
                  <KundenDaten />
                </div>
                <div className="col-1"></div>
                {!configStorage.isAnkaufShop() || mandantStorage.ablieferadresseAnkauf()
                  ? <div className="col-12 col-lg-5 fs-5">
                    <h3 className="fw-bold text-gray">
                      {!configStorage.isAnkaufShop() ? "Lieferadresse" : "Ablieferadresse"}
                    </h3>
                    <Address
                      kunde={kunde}
                      doShip={basketStorage.doShip}
                      selectedFiliale={basketStorage.selectedFiliale}
                      isMaShop={this.props.configStorage.isMaShop()}
                      isEditable={mandantStorage.lieferadresseIsEditable() && mandantStorage.abwAdresseBsErlaubt() && (direktbestellung || !basketStorage.selectedFiliale)}
                    />
                  </div>
                  : null
                }
              </section>
              <section className="row" aria-label="Bestellung">
                <h3 className="aria-visible">Bestellung</h3>
                <div className="col-12 mb-1 fs-5">
                  <Order
                    warenkorbPos={basketStorage.getWarenkorbPos()}
                    handleRemark={this.handleRemark}
                  />
                </div>
              </section>
              <section aria-label="Summe">
                <Summe emProvZusKz={this.state.emProvZusKz} beraterFeld={this.state.beraterFeld} />
              </section>
              <section aria-label="Rechtliche Hinweise">
                <RechtlicheHinweise
                  handleGeneralChange={this.handleGeneralChange}
                  updateHinweise={this.updateHinweise}
                  showBeraterErrorMsg={this.state.showBeraterErrorMsg}
                  beraterFeld={this.state.beraterFeld}
                  rechtlichesHinweis={this.state.rechtlichesHinweis}
                  showRechtlichesHinweisErrorMsg={this.state.showRechtlichesHinweisErrorMsg}
                />
                {this.state.showRequiredWarning
                  ? <Alert>Bitte füllen Sie die Pflichtfelder aus.</Alert>
                  : null
                }
              </section>
              <div className="row mb-one justify-content-between gap-one-half">
                <div className="col-md-2">
                  <Link
                    onClick={this.cleanupModal}
                    to={configStorage.getBackToShopLink()}
                    className="btn btn-info col-12"
                  >
                    Zurück zum Shop
                  </Link>
                </div>
                <div className="btn-group col-md-4 col-lg-5 flex-wrap gap-one-half">
                  {configStorage.kundeIsSelectable() && !authenticationStorage.kundenId && this.state.tlsCodeVerifyCount <= 4
                    ? <Link
                      onClick={this.cleanupModal}
                      to={configStorage.getLinkPath("LINK_MITARBEITER_ADD_KUNDEN")}
                      className="btn btn-default"
                    >
                      Zu Kundendaten
                    </Link>
                    : null
                  }
                  {basketStorage.selectedFiliale === null && mandantStorage.lieferadresseIsEditable() && this.state.tlsCodeVerifyCount <= 4  && !configStorage.isDeuBa()
                    ? (
                      <Link
                        onClick={this.cleanupModal}
                        to={configStorage.getLinkPath("LINK_KUNDEN_ADDRESSE_MA", kunde.id)}
                        className="btn btn-default ms-lg-one"
                      >
                        Zu Kundenadressen
                      </Link>
                    )
                    : null
                  }
                </div>
                {this.renderBestaetigung()}
                {configStorage.isVerseNeo()
                  ? (
                    <div className="w-100 ms-lg-one">
                      <BackToStartButton onClick={this.cleanupModal} className="w-100" />
                    </div>
                  )
                  : null
                }
              </div>
              <ServiceContactInfo/>
              <div className="d-md-none buffer-area"></div>
            </div>
          </div>
        </section >
      </div >
    );
  }
}

export default connect(store => {
  return {
    basketStorage: store.basketStorage,
    configStorage: store.configStorage,
    kundenStorage: store.kundenStorage,
    metalsStorage: store.metalsStorage,
    mandantStorage: store.mandantStorage,
    authenticationStorage: store.authenticationStorage,
    rightStorage: store.rightStorage,
    requiredRageRight: [RAGE_RIGHT.RAGE_BERATER_EINS, RAGE_RIGHT.RAGE_BERATER_ZWEI]
  };
})((props) => {
  const match = useMatch() || {};
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <KundenOrderDetailsMA params={match.params || {}} navigate={contextNavigate} {...props} />;
});
